// surf_zenite — T3, 3 stages, ESPAÇO (vácuo embaixo). Air strafe puro:
// gaps enormes, rampas estreitas, bhop em plataformas flutuantes e ATALHO extremo.
import { Course } from '../course';
import type { GameMap } from '../types';
import { finishMap } from './util';

export function buildZenite(): GameMap {
  const c = new Course(0, 0, 256, 0);

  // === Stage 1: o salto entre mundos ===
  c.spawnHere(-224);
  c.zoneOver(c.platform(192, 448), 'start');
  c.drop(544);
  c.ramp(512, 512, 2400);
  c.advance(512); // GAP gigante — mire e confie no strafe
  c.ramp(512, 512, 2400);
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(448, 640), 'stage', { index: 2 });

  // === Stage 2: bhop flutuante + transferência estreita ===
  c.bhopGaps(5, 224, 384, 224);
  c.drop(528);
  c.shift(512);
  c.ramp(448, 512, 2000);
  c.drop(16);
  c.spawnHere(-224);
  c.zoneOver(c.platform(768, 640), 'stage', { index: 3 });

  // === Stage 3: zigue-zague estreito + ATALHO central quase impossível ===
  c.drop(544);
  c.mark();
  c.ramp(288, 512, 5860, 'short'); // atalho: agulha central contínua
  c.restore();
  c.ramp(448, 512, 1800);
  c.shift(-576);
  c.advance(160);
  c.ramp(448, 512, 1800);
  c.shift(1152);
  c.advance(160);
  c.ramp(512, 512, 1800);
  c.shift(-576);
  c.advance(140);
  c.drop(16);
  c.zoneOver(c.platform(1024, 768, 'accent'), 'end');

  return finishMap(c, 'surf_zenite');
}
